import { SectionTitle } from '@/components/shared/Content';
import { Box, Flex, font, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type React from 'react';
import styled from 'styled-components';

export const SectionWrapper = styled(Flex).attrs(() => ({
  alignItems: 'center',
  flexDirection: 'column',
  as: 'section',
}))`
  padding-top: 0;
  padding-bottom: 30px;
  background-color: ${themedColor('glass')};

  ${MEDIA_QUERIES.tabletAndDesktop`
        padding-top: 0;
        padding-bottom: 100px;
    `}
`;

export const SectionWrapperInner = styled(Flex).attrs({
  justifyContent: 'center',
  flexDirection: 'column',
})`
  ${MEDIA_QUERIES.tabletAndDesktop`
      max-width: 1144px;
      width: 100%;
  `}
`;

export const SectionHeader = styled.h2`
  text-align: center;
  ${font('main', { fontSize: '2.4rem', lineHeight: '48px', fontWeight: 700 })}

  ${MEDIA_QUERIES.tabletAndDesktop`
        ${font('main', {
          fontSize: '3.8rem',
          lineHeight: '48px',
          fontWeight: 700,
        })}
        margin-bottom: 11px;
    `}
`;

export const SectionTitlePet = styled(SectionTitle)`
  text-wrap: pretty;
  ${MEDIA_QUERIES.tabletAndDesktop`
        ${font('main', {
          fontSize: '4.4rem',
          lineHeight: '5.6rem',
          fontWeight: 'bold',
        })}
    `}
`;

export const DesktopOnlyBreak = styled.br`
  display: none;

  ${MEDIA_QUERIES.tabletAndDesktop`
        display: block;
    `}
`;

export const SectionSubtitle = styled(Box)`
  text-wrap: balance;
  ${font('main', { fontSize: '2.0rem', lineHeight: '2.8rem' })}
  text-align: center;
  margin: 20px auto 58px auto;

  ${MEDIA_QUERIES.tabletAndDesktop`
        ${font('main', { fontSize: '1.8rem', lineHeight: '2.8rem' })}
    `}
  ${MEDIA_QUERIES.mobile`
        padding: 0 1rem;
    `}
`;

export const ListTitle = styled(Flex)`
  width: 100%;
  ${font('main', {
    fontSize: '2.0rem',
    lineHeight: '3.0rem',
    fontWeight: 'bold',
  })}
`;

export const ListItem = styled(Flex)`
  width: 100%;
  ${MEDIA_QUERIES.tabletAndDesktop`
        flex-direction: column;
        flex: 0 1 262px;
    `}
`;

const MOBILE_SIZE = 68;
const DESKTOP_SIZE = 175;

export const StyledImage = styled.img`
  width: ${MOBILE_SIZE}px;
  height: ${MOBILE_SIZE}px;
  margin-bottom: 7px;

  ${MEDIA_QUERIES.tabletAndDesktop`
        width: ${DESKTOP_SIZE}px;
        height: ${DESKTOP_SIZE}px;
        margin: 0;
    `}
`;

interface ListItemImageProps {
  src: string;
  title: string;
  isMobile: boolean;
  alt?: string;
}
export const ListItemImage: React.FC<ListItemImageProps> = ({ src, title, isMobile, alt }) => {
  return (
    <Flex mr={[14, 0]}>
      <StyledImage
        src={src}
        alt={alt ?? title}
        width={isMobile ? MOBILE_SIZE : DESKTOP_SIZE}
        height={isMobile ? MOBILE_SIZE : DESKTOP_SIZE}
      />
    </Flex>
  );
};

export const ListItemInfo = styled(Flex)``;

export const ListItemTitle = styled(Flex)`
  text-wrap: balance;
  ${font('main', {
    fontSize: '1.6rem',
    lineHeight: '1.6rem',
    fontWeight: 700,
  })};
  margin-bottom: 5px;
  width: 100%;

  ${MEDIA_QUERIES.tabletAndDesktop`
        ${font('main', {
          fontSize: '1.5rem',
          lineHeight: '2.2rem',
          fontWeight: 700,
        })};
        justify-content: center;
        margin-top: 25px;
        text-align: center;
        text-transform: uppercase;
    `}
`;

export const ListItemDescription = styled(Flex)`
  text-wrap: balance;
  width: 100%;
  ${font('main', { fontSize: '1.4rem', lineHeight: '1.9rem' })};
  color: ${themedColor('boulder')};

  ${MEDIA_QUERIES.tabletAndDesktop`
        ${font('main', { fontSize: '1.6rem', lineHeight: '2.1rem' })};
        text-align: center;
        justify-content: center;
    `}
`;
